import React, {useMemo} from 'react';

import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import {useCheckOrder} from '../../hooks/returningCustomerCL/useCheckOrder/useCheckOrder';

type QueryProvidedDataType = {
    checkOrderData: ReturnType<typeof useCheckOrder>;
};

type PropsType = {
    children: (data: QueryProvidedDataType) => React.ReactNode;
};

/**
 * RootQueryFlowDataProvider component needs to provide query hooks in class components
 * we can remove it after root of the cart components will be React.FC
 */
export const RootQueryFlowDataProvider: React.FC<PropsType> = props => {
    const customer = useGetCustomerData();
    const isCustomerRequestDone = useMemo(
        () => customer.status === 'FULFILLED' || customer.status === 'REJECTED',
        [customer.status],
    );

    const checkOrderData = useCheckOrder({enabled: Boolean(isCustomerRequestDone)});

    return <>{props.children({checkOrderData})}</>;
};
